export interface NewClientPatientCreateFormValues {
  email: string
  phone: string
}

export interface NewClientPatientRecommendationFormValues {
  proName: string
}

export interface NewClientProfessionalCreateFormValues {
  profession: string
  email: string
  phone: string
}
export const professions = [
  { id: "kine", labelKey: "kine" },
  { id: "surgeon", labelKey: "surgeon" },
  { id: "gp", labelKey: "gp" },
  { id: "other", labelKey: "other" },
]
